import { Component, EventEmitter, Output } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { SolLaborByLevelComponent } from "./sol-labor-by-level/sol-labor-by-level.component";
import { SolTaskByLevelComponent } from "./sol-task-by-level/sol-task-by-level.component";

@Component({
  selector: 'app-sol-other-tab',
  imports: [
    CommonModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    TranslatePipe,
    SolLaborByLevelComponent,
    SolTaskByLevelComponent
],
  templateUrl: './sol-other.component.html',
  styleUrl: './sol-other.component.scss'
})
export class SolOtherTabComponent {
    otherPageOptions: FormControl = new FormControl('1');

  @Output() disablePdf  = new EventEmitter<boolean>();

  ngOnInit() {
    this.sendDisablePdfEvent();
  }

  sendDisablePdfEvent() {
    this.disablePdf.emit(true);
  }
}
